import Icon from '../components/Icon.vue'

Icon.register({"chevron-circle-down":{"width":512,"height":512,"paths":[{"d":"M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM273 369.9L408.5 234.4C417.9 225 417.9 209.8 408.5 200.5L391.5 183.5C382.1 174.1 366.9 174.1 357.6 183.5L256 285.1 154.4 183.5C145 174.1 129.8 174.1 120.5 183.5L103.5 200.5C94.1 209.9 94.1 225.1 103.5 234.4L239 369.9C248.4 379.3 263.6 379.3 273 369.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chevron-circle-down.js
// module id = 5p9p
// module chunks = 0